import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotel-list-loader',
  templateUrl: './hotel-list-loader.component.html',
  styleUrls: ['./hotel-list-loader.component.scss']
})
export class HotelListLoaderComponent implements OnInit {
  listGrid = true;
  constructor() { }

  ngOnInit(): void {
  }

}
